import script from "./LegalCasesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalCasesPanel.vue?vue&type=script&setup=true&lang=js"

import "./LegalCasesPanel.vue?vue&type=style&index=0&id=de55e612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de55e612"]])

export default __exports__